import { splitPath } from "../objectPaths.js";
import { handleArrayPath } from "./helpers.js";
/**
 * Mutate the state at the given path. TODO: The casts here need work.
 *
 * @template T The type of the state.
 * @param prevState The function to update the state.
 * @param path The path to the value to update.
 * @param newValue The new value to set.
 * @throws TypeError If the new value is not of the same type as the existing
 *   value.
 * @throws Error If the path is not valid for the state.
 */
export function updateStateAtPath(prevState, path, newValue) {
    const pathParts = splitPath(path);
    let target = prevState;
    const newValueType = typeof newValue;
    for (let i = 0; i < pathParts.length; i++) {
        const part = pathParts[i];
        if (i === pathParts.length - 1) {
            const targetType = typeof target[part];
            if (newValueType === "undefined" ||
                newValueType === targetType ||
                targetType === "undefined") {
                target[part] = newValue;
            }
            else {
                throw new TypeError(`New value "${typeof newValue === "object" ? JSON.stringify(newValue) : newValue}" of type ${newValueType} for ${JSON.stringify(pathParts)} is not of type ${typeof target[part]}`);
            }
        }
        else {
            const arrayMatch = handleArrayPath(part, target, {
                fieldName: path,
                lastSegment: pathParts[i - 1] || "/",
            });
            if (arrayMatch) {
                target = arrayMatch;
            }
            else {
                if (!(part in target)) {
                    throw new Error(`Path "${path}" is not valid`);
                }
                target = target[part];
            }
        }
    }
}
/**
 * Call the state setter with the updated state.
 *
 * @template T The type of the state.
 * @param stateSetter The function to update the state. (Typically the
 *   React.useState setter).
 * @param path The path to the value to update.
 * @param newValue The new value to set.
 */
export function updateStateFromPrevious(stateSetter, path, newValue) {
    stateSetter((prevState) => {
        const toUpdate = { ...prevState };
        updateStateAtPath(toUpdate, path, newValue);
        return toUpdate;
    });
}
//# sourceMappingURL=stateUpdating.js.map